
import { Component, Mixins, Prop } from 'vue-property-decorator'
import { processedUrl } from '@padlet/vivaldi-client'

const ANONYMOUS_AVATAR = 'https://padlet.net/avatars/alien1.png'

@Component({ components: {} })
export default class OzAvatar extends Mixins() {
  isErrored = false

  /**
   * width of the avatar
   */
  @Prop({ required: false }) width!: number

  /**
   * height of the avatar
   */
  @Prop({ required: false }) height!: number

  /**
   * Image source URL
   */
  @Prop({ required: true }) src!: string | null

  /**
   * Fallback image source URL
   */
  @Prop({ required: false, default: ANONYMOUS_AVATAR }) fallbackSrc!: string

  /**
   * Name of account to display for alt text.
   */
  @Prop({ required: false, default: 'anonymous' }) altTextName!: string

  get processedSrc(): string {
    if (!this.src || this.isErrored) return this.fallbackSrc

    // for relative urls e.g. when developing locally
    if (this.src.startsWith('/')) return this.src

    return processedUrl(this.src, this.transforms)
  }

  get altText(): string {
    return this.__('Avatar of %{name}', { name: this.altTextName })
  }

  get transforms(): { width?: number; height?: number; preset: string } {
    if (this.width && this.height) {
      return {
        width: this.width,
        height: this.height,
        preset: 'avatar',
      }
    }
    return {
      preset: 'avatar',
    }
  }
}
